import React from 'react'
import AppRouter from './Routers/AppRouter'

const App = () => {
  return <AppRouter/>
}

export default App;
